import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Image, StyleSheet, View } from 'react-native';

import FamilyInfoForm from '../../components/register/FamilyInfoForm/FamilyInfoForm';
import Colors from '../../constants/Colors';
import Layout from '../../constants/Layout';
import Languages from '../../constants/Languages';
import * as Actions from '../../store/Actions';
import { capitalize } from '../../utils/stringFunctions';
import Header from '../../components/register/Header';
import MyScrollView from '../../components/MyScrollView';

class FamilyDetailsScreen extends Component {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
  }

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('UserDetails');
  };

  goNext = (data) => {
    const { actions, navigation } = this.props;
    actions.updateUser(data);
    navigation.navigate('AdditionalDetails');
  };

  render() {
    const { registration } = this.props;
    const { language } = registration;
    const translation = Languages.translations[language?.name || 'en'];
    const tellFamily = translation.fragment_registration_family_textview_title;
    return (
      <MyScrollView
        containerStyle={styles.containerStyle}
        contentContainerStyle={styles.contentContainerStyle}
        compressHeight={0.9}
      >
        <Header title={capitalize(tellFamily)} goBack={this.goBack} />
        <View style={styles.centerContainer}>
          <View style={styles.welcomeContainer}>
            <Image source={require('../../assets/images/tell_family.png')} style={styles.welcomeImage} />
          </View>
          <View style={styles.getStartedContainer}>
            <FamilyInfoForm
              translation={translation}
              goBack={this.goBack}
              goNext={this.goNext}
              registration={registration}
            />
          </View>
        </View>
      </MyScrollView>
    );
  }
}

const styles = StyleSheet.create({
  containerStyle: {
    backgroundColor: Colors.mediumBlue,
  },
  contentContainerStyle: {
    flex: 1,
    backgroundColor: Colors.lightBackground,
    alignItems: 'center',
  },
  centerContainer: {
    flex: 1,
    backgroundColor: Colors.white,
    alignItems: 'center',
    maxWidth: 720,
    width: '100%',
  },
  welcomeContainer: {
    alignItems: 'center',
    backgroundColor: Colors.backgroundBlue,
    maxWidth: Layout.mobile - 200,
    width: '100%',
  },
  welcomeImage: {
    height: 184,
    width: '100%',
    resizeMode: 'contain',
    marginTop: 3,
    marginLeft: -10,
  },
  getStartedContainer: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'stretch',
    maxWidth: Layout.mobile - 200,
    width: '100%',
  },
  bottomContainer: {
    backgroundColor: Colors.white,
  },
});

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FamilyDetailsScreen);
